export default __webpack_public_path__ + "static/media/exit-load-icon.82e48960.svg";